/**
 * Firebase Configuration
 * 
 * SETUP INSTRUCTIONS:
 * 1. Go to https://console.firebase.google.com/
 * 2. Select your project
 * 3. Click on Project Settings (gear icon)
 * 4. Scroll down to "Your apps" section
 * 5. If no web app exists, click "Add app" (</>)
 * 6. Copy the configuration object
 * 7. Replace the firebaseConfig below with your credentials
 * 8. Enable Firestore Database in Firebase Console:
 *    - Go to Firestore Database
 *    - Click "Create database"
 *    - Start in test mode (we'll add security rules later)
 */

import { initializeApp } from 'firebase/app';
import {
    initializeFirestore,
    persistentLocalCache,
    persistentMultipleTabManager
} from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";

// Firebase configuration using environment variables
const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
let app;
let db;
let auth;
let analytics;

try {
    app = initializeApp(firebaseConfig);

    // Initialize Firestore with modern persistence settings
    db = initializeFirestore(app, {
        localCache: persistentLocalCache({
            tabManager: persistentMultipleTabManager()
        })
    });

    auth = getAuth(app);

    // Initialize Analytics only in browser environment
    if (typeof window !== 'undefined') {
        analytics = getAnalytics(app);
    }

} catch (error) {
    console.error('Firebase initialization error:', error);
}

export { app, db, auth, analytics };
